import { render } from "./UserSearchSelect.vue?vue&type=template&id=21047b3f"
import script from "./UserSearchSelect.vue?vue&type=script&lang=js"
export * from "./UserSearchSelect.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__